import type { AuditLogEntry } from '@core/api/auditLog';
import { AuditAction } from '@core/enum/auditAction';
import { hasAuditLogDetails } from '@core/utils/auditLog';

export function hasOrderHistoryDetails(entry: AuditLogEntry): boolean {
  if (
    entry.action === AuditAction.EntityDuplicated ||
    entry.action === AuditAction.OrderStatusChanged ||
    entry.action === AuditAction.ProductionStageChanged ||
    entry.action === AuditAction.JobOrderPrinted
  ) {
    return false;
  }

  return hasAuditLogDetails(entry);
}
